import React from 'react'
import {VstButton} from 'vstui';
import TransactionAction from '../actions/transaction-action';
import TransactionStore from '../stores/transaction-store';

const _hideModal = (transactionNumber) => {
  TransactionAction.showDetails(transactionNumber);
  return true;
};

export const RefundComplete = ({ transactionNumber }) => {

  // NOTE: remove if statement when receiving whole refund transaction from api
  return (
    <div className='refund-complete'>
      <img src={require('../../img/success_icon.svg')} role="presentation" style={{width: '90px', height: '90px'}}/>
      <p className='success-message'>{i18n.t("refunds.bulk.success")}</p>
      <VstButton
        className='view-details'
        options="btn-36"
        onClick={() =>_hideModal(transactionNumber)}
        >
        {i18n.t('base.close')}
      </VstButton>
    </div>
  );
}

export const RefundFailed = ({retry, transactionNumber}) => {
  return (
    <div className='refund-failed'>
      <img src={require('../../img/error_icon.svg')} role="presentation" style={{width: '90px', height: '90px'}}/>
      <p className='refund-failure-message'>{i18n.t("refunds.bulk.failure")}</p>
      <VstButton options="btn-36" onClick={retry} className='try-again'>{i18n.t("refunds.bulk.retry")}</VstButton>
      <a href={Mulligan.Brand.Support.url} target="_blank" className="vst-href-text-button close-refund-complete" onClick={() => _hideModal(transactionNumber)}>{i18n.t('refunds.bulk.support')}</a>
    </div>
  );
}

export default RefundComplete
